import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white rounded-md border border-gray-lp-400"
}
const _hoisted_2 = { class: "flex flex-row items-center justify-between px-6 py-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Total Pick Up", -1)
const _hoisted_4 = { class: "flex items-center gap-2 text-black-lp-300" }
const _hoisted_5 = { class: "w-full px-6 pb-4" }
const _hoisted_6 = { class: "flex flex-row gap-4" }
const _hoisted_7 = { class: "flex-1 rounded-md border border-gray-lp-400 p-3" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = { class: "flex-1 rounded-md border border-gray-lp-400 p-3" }
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = { class: "flex-1 rounded-md border border-gray-lp-400 p-3" }
const _hoisted_14 = { class: "flex items-center gap-2" }
const _hoisted_15 = { class: "mt-2" }
const _hoisted_16 = {
  key: 1,
  class: "w-full rounded-2xl border border-red-lp-2800"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "text-black-lp-300 text-base font-semibold" }, " Total Pick Up ", -1)
const _hoisted_18 = { class: "flex items-center gap-2" }
const _hoisted_19 = { class: "text-black-lp-300 text-20px font-bold space-x-1" }
const _hoisted_20 = { class: "relative group inline-flex items-baseline" }
const _hoisted_21 = {
  class: "absolute left-0 z-50 whitespace-nowrap bg-gray-lp-600 text-white text-12px rounded px-2 py-1 shadow opacity-0 group-hover:opacity-100",
  style: {"top":"100%"}
}
const _hoisted_22 = { class: "relative group text-12px font-light inline-flex" }
const _hoisted_23 = {
  class: "absolute left-0 z-50 whitespace-nowrap bg-gray-lp-600 text-white text-12px rounded px-2 py-1 shadow opacity-0 group-hover:opacity-100",
  style: {"top":"100%"}
}
const _hoisted_24 = { class: "w-full px-4 pb-4" }
const _hoisted_25 = { class: "flex flex-row gap-4" }
const _hoisted_26 = { class: "flex items-center gap-2" }
const _hoisted_27 = { class: "text-black-lp-300 text-sm font-semibold" }
const _hoisted_28 = { class: "mt-2 text-black-lp-100 space-x-1" }
const _hoisted_29 = { class: "relative group inline-flex items-baseline" }
const _hoisted_30 = { class: "text-24px font-bold" }
const _hoisted_31 = {
  class: "absolute left-0 z-50 whitespace-nowrap bg-gray-lp-600 text-white text-12px rounded px-2 py-1 shadow opacity-0 group-hover:opacity-100",
  style: {"top":"100%"}
}
const _hoisted_32 = { class: "text-black-lp-300 text-20px font-semibold opacity-80" }
const _hoisted_33 = { class: "relative group text-black-lp-200 text-sm inline-flex" }
const _hoisted_34 = {
  class: "absolute left-0 z-50 whitespace-nowrap bg-gray-lp-600 text-white text-12px rounded px-2 py-1 shadow opacity-0 group-hover:opacity-100",
  style: {"top":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_Skeleton, {
                height: "1rem",
                width: "10rem"
              })
            ])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_Skeleton, {
                    height: "1.2rem",
                    width: "1.2rem"
                  }),
                  _createVNode(_component_Skeleton, {
                    height: "1rem",
                    width: "8rem"
                  })
                ]),
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_Skeleton, {
                    height: "1.2rem",
                    width: "14rem"
                  })
                ])
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_Skeleton, {
                    height: "1.2rem",
                    width: "1.2rem"
                  }),
                  _createVNode(_component_Skeleton, {
                    height: "1rem",
                    width: "8rem"
                  })
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_Skeleton, {
                    height: "1.2rem",
                    width: "14rem"
                  })
                ])
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode(_component_Skeleton, {
                    height: "1.2rem",
                    width: "1.2rem"
                  }),
                  _createVNode(_component_Skeleton, {
                    height: "1rem",
                    width: "8rem"
                  })
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode(_component_Skeleton, {
                    height: "1.2rem",
                    width: "14rem"
                  })
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_16, [
          _createVNode("div", {
            class: "flex flex-row items-center justify-between px-4 py-2 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setIsExpanded(!_ctx.isExpanded)))
          }, [
            _hoisted_17,
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode("span", _hoisted_20, [
                  _createTextVNode(_toDisplayString(_ctx.formatCompactNumber(_ctx.totalShipment)) + " " + _toDisplayString(_ctx.$t('pickupDashboard.package')) + " ", 1),
                  _createVNode("div", _hoisted_21, _toDisplayString(_ctx.formatNumber(_ctx.totalShipment)), 1)
                ]),
                _createVNode("span", _hoisted_22, [
                  _createTextVNode(" (" + _toDisplayString(_ctx.formatCompactNumber(_ctx.totalQuantity)) + " " + _toDisplayString(_ctx.$t('pickupDashboard.koli')) + ") ", 1),
                  _createVNode("div", _hoisted_23, _toDisplayString(_ctx.formatNumber(_ctx.totalQuantity)), 1)
                ])
              ]),
              _createVNode("img", {
                src: 
                require(`@/app/ui/assets/svg/${
                  _ctx.isExpanded ? 'chevron-up' : 'chevron-down'
                }.svg`)
              ,
                class: "w-4",
                alt: "toggle"
              }, null, 8, ["src"])
            ])
          ]),
          _withDirectives(_createVNode("div", _hoisted_24, [
            _createVNode("div", _hoisted_25, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cards, (card) => {
                return (_openBlock(), _createBlock("div", {
                  class: "flex-1",
                  key: card.status
                }, [
                  _createVNode(_component_Card, {
                    rounded: "xl",
                    class: "w-full flex flex-col p-2",
                    isShadow: false,
                    customClass: 'border border-red-lp-2800',
                    style: {
                  backgroundImage: `url(${require('@/app/ui/assets/svg/bg-summary-card.svg')})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'top right',
                  backgroundSize: '-100% 50%'
                }
                  }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_26, [
                        _createVNode("img", {
                          src: 
                      require(`@/app/ui/assets/svg/${
                        _ctx.statusMaps[card.status].icon
                      }.svg`)
                    ,
                          class: "w-4",
                          alt: "icon"
                        }, null, 8, ["src"]),
                        _createVNode("div", _hoisted_27, _toDisplayString(_ctx.statusMaps[card.status].title), 1)
                      ]),
                      _createVNode("div", _hoisted_28, [
                        _createVNode("span", _hoisted_29, [
                          _createVNode("span", _hoisted_30, _toDisplayString(_ctx.formatCompactNumber(card.mainValue)), 1),
                          _createVNode("div", _hoisted_31, _toDisplayString(_ctx.formatNumber(card.mainValue)), 1)
                        ]),
                        _createVNode("span", _hoisted_32, _toDisplayString(card.mainLabel), 1),
                        _createVNode("span", _hoisted_33, [
                          _createTextVNode(" (" + _toDisplayString(_ctx.formatCompactNumber(card.subValue)) + " " + _toDisplayString(card.subLabel) + ") ", 1),
                          _createVNode("div", _hoisted_34, _toDisplayString(_ctx.formatNumber(card.subValue)), 1)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["style"])
                ]))
              }), 128))
            ])
          ], 512), [
            [_vShow, _ctx.isExpanded]
          ])
        ]))
  ]))
}